import { adminAPI } from '../services/api';

function downloadCsvBlob(res, fallbackName) {
  const disposition = String(res.headers['content-disposition'] || '');
  const star = disposition.match(/filename\*=UTF-8''([^;]+)/i);
  let filename = fallbackName;
  if (star) {
    try {
      filename = decodeURIComponent(star[1].trim()) || filename;
    } catch {
      /* keep fallback */
    }
  } else {
    const q = disposition.match(/filename="([^"]+)"/i);
    if (q?.[1]) filename = q[1];
  }
  const blob = new Blob([res.data], { type: 'text/csv;charset=utf-8;' });
  const href = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = href;
  a.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(href);
  return {
    truncated: String(res.headers['x-export-truncated'] || '').toLowerCase() === 'true',
    rowCount: res.headers['x-ticket-export-rows']
  };
}

/**
 * Download CSV for all ticket bookings matching current Tickets page filters.
 */
export async function exportTicketsCsvForFilters(params) {
  const res = await adminAPI.exportTicketsCsvByFilters(params);
  const stamp = new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Kolkata' }).format(new Date());
  const meta = downloadCsvBlob(res, `tickets-export-${stamp}.csv`);
  const rowCount = meta.rowCount != null ? Number(meta.rowCount) : null;
  return {
    rowCount: Number.isFinite(rowCount) ? rowCount : null,
    truncated: meta.truncated
  };
}
